<!-- Hero Start -->
<section class="home-slider position-relative" id="home">
    <ngb-carousel [showNavigationIndicators]="showNavigationIndicators">
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/3r/cover/students-1807505_640.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Private office and-->
                                <!--                                    Co-working space for <span class="text-success">$19</span></h6>-->
                                <h1 class="display-4 title-dark font-weight-bold text-white mb-3">{{detail.name}}</h1>
                                <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/3r/cover/medium-shot-woman-taking-notes.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">The Best Coworking in The-->
                                <!--                                    City</h6>-->
                                <h1 class="display-4 title-dark font-weight-bold text-white mb-3">{{detail.name}}</h1>
                                <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>
                                <!--end subscribe form-->
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center" style="background-size:cover; background-image:url('assets/images/coworking/medium-shot-people-graduating.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Our Space for You</h6>-->
                                <h1 class="display-4 title-dark font-weight-bold text-white mb-3">{{detail.name}}</h1>
                                <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
    </ngb-carousel>

    <!--end carousel inner-->

    <!-- </div> -->
</section>
<div class="container mt-100 mt-60 mb-5">
    <div class="row align-items-center">
        <div class="col-lg-5 col-md-6 mt-4 pt-2">
            <img style="width:28rem" src="assets/3r/websites%20post%20newar%20description.jpg" alt="">
        </div>
        <!--end col-->

        <div class="col-lg-7 col-md-6 mt-4 pt-2">
            <div class="section-title ml-lg-5">
                <h4 class="title mb-4">WHY {{detail.name}}</h4>
                <p class="text-muted">{{detail.why}}</p>
            </div>
        </div>
        <!--end col-->
    </div>
    <!--end row-->
</div>

<div class="container mt-100 mt-60 mb-5">

    <div class="row align-items-center mb-4">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title mb-2 mt">REASONS TO {{detail.name}}</h4>
                <div class="section-title ml-lg-5 justify-content-center">
                    <ul>
                        <!--                        <li *ngFor="let f of detail.reasonList">{{f.reason}}</li>-->
                        <ul class="list-unstyled mb-0 pl-0 tex">
                            <li *ngFor="let f of detail.reasonList" class="h6 text-muted mb-0 text-left">
                                <span class="text-primary h5 mr-2"> ♦ </span> {{f.reason}}
                            </li>

                        </ul>
                    </ul>
                </div>
            </div>
        </div>
        <!--end col-->
        <!--        <div class="col-12 mt-4 pt-2">-->

        <!--        </div>-->


    </div>

    <div class="row align-items-center">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title  mt">Top Courses</h4>
            </div>
        </div>
        <!--end col-->
        <div class="col-lg-7 col-md-6 mt-4 pt-2" *ngFor="let x of cors">
            <div class="section-title ml-lg-5">
                <h5 class="mb-2 font-weight-bold">{{x.name}}</h5>
                <p class="text-muted">{{x.description}}</p>
            </div>
        </div>


    </div>
    <!--end row-->

    <div class="container mt-100 mt-60 mb-5">
        <div class="row align-items-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4 mt">Top Universitys</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 mt-4 pt-2" *ngFor="let d of uni">
                    <div class="card blog rounded border-0 shadow">
                        <div class="position-relative">
                            <img src="data:image/png;base64,{{d.image}}" class="card-img-top rounded-top" alt="...">
                            <div class="overlay rounded-top bg-dark"></div>
                        </div>
                        <div class="card-body content" style="height: 8rem">
                            <h6><a href="javascript:void(0)"
                                   class="card-title font-weight-bold text-dark text-center">{{d.name}}</a>
                            </h6>
                            <!--                            <p class="text-muted">{{d.description | slice:0:40}} ...</p>-->
                            <!--                            <button (click)="booking(d)" class="btn-sm btn  btn-primary mr-3">See more</button>-->
                        </div>

<!--                        <div class="author">-->
<!--                            <small class="text-light user d-block"><i class="mdi mdi-account"></i> Calvin Carlo</small>-->
<!--                            <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 13th August,-->
<!--                                2019</small>-->
<!--                        </div>-->
                    </div>
                </div>
                <!--end col-->

            </div>
        </div>
    </div>
</div>
